module.exports = __webpack_public_path__ + "static/media/azimut-icons.0256f4c5.svg";